<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<span *ngIf="!isFkLink"
      [attr.data-value]="recordValue"
      [ngClass]="spanClass"
      [title]="title">{{displayValue}}
  <a *ngIf="sfHref"
     [href]="sfHref"
     rel="salesforce"
     target="_blank">In Salesforce
  </a>
</span>
<a *ngIf="isFkLink"
   [attr.data-value]="[recordValue]"
   [ngClass]="cssClass"
   [routerLink]="fkLink"
   [title]="title">{{displayValueFk}}</a>
